import { ref } from "vue";
import router from "@/router";
import { getApi, postApi, showNotif } from "./AppService";
import { NotifEnum } from "@/models/components/NotifEnum";

const ENV = import.meta.env.VITE_ENV;
const API_BASE_URL = import.meta.env.VITE_API_URL;
const API_SOCKET_URL = import.meta.env.VITE_API_SOCKET;
const API_O2_URL = import.meta.env.VITE_O2_URL;
const FRONT_URL = import.meta.env.VITE_FRONT_URL;
const BLOB_URL = import.meta.env.VITE_BLOB_URL;
const token = ref(window.localStorage.getItem('jwt_token'));
const picture = ref(window.localStorage.getItem('picture'));
const isLoggedIn = ref(false);
const isAdmin = ref(false);

const setAuthHeader = (token: string | null) => {
  if (token) {
    window.localStorage.setItem('jwt_token', token);
  } else {
    window.localStorage.clear();
  }
};

const setCookie = (mail: string, name: string, id: number, picture: string) => {
  window.localStorage.setItem('user_name', name);
  window.localStorage.setItem('user_mail', mail);
  window.localStorage.setItem('picture', picture);
  window.localStorage.setItem('user_id', id.toString());
};

const login = async (email: string, password: string, toRedirect: string) => {
  await postApi('/Auth/Login', { email, password }).then(response => {
    if (response.success) {
      token.value = response.token;
      setAuthHeader(token.value);
      setCookie(email, response.fullName, response.id, response.picture);
      isLoggedIn.value = true;
      router.push(toRedirect);
    } else {
      isLoggedIn.value = false;
      showNotif(response.message, NotifEnum.ERROR);
    }
  });
};

const logout = () => {
  token.value = null;
  isLoggedIn.value = false;
  isAdmin.value = false;
  setAuthHeader(null);
  router.push('/');
};

const checkLoggedIn = async (): Promise<boolean> => {
  if (token.value != null) {
    try {
      const response = await fetch(`${API_BASE_URL}/Users/IsLoggedIn`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token.value}`,
        },
      });
      isLoggedIn.value = response.ok;
      return isLoggedIn.value;
    }
    catch (error) {
      logout();
    }
  }
  return false;
};

const checkIsAdmin = async (): Promise<boolean> => {
  if (token.value != null) {
    try {
      const response = await getApi('/Users/IsAdmin');
      return response.success;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
  return false;
};

export { login, logout, checkLoggedIn, checkIsAdmin, isLoggedIn, isAdmin, token, picture, API_BASE_URL, ENV, API_SOCKET_URL, FRONT_URL, API_O2_URL, BLOB_URL };